import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from 'hooks/ui';
import { rejectBroadcast } from 'api/broadcasts.service';
import { setDraftBroadcast } from 'store/broadcast';
import { useApplicationStore } from 'store/application';
import { broadcastKeys } from './queryKeys';

export const useBroadcastRejectQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return rejectBroadcast(id);
    },
    onSuccess: (broadcast) => {
      toast.success('Broadcast has been rejected successfully');
      setDraftBroadcast(broadcast);
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: broadcastKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
